import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import headerIcon from "../images/FullHeaderIcon.png";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border-bottom: 1px solid rgb(192 196 202);
`;

const HeaderContainer = styled.div`
  display: flex;
  margin: 10px 10px;
`;

const MainPicture = styled.img`
  margin-bottom: 5px;
  width: 70%;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 10px;
  border: 1px solid rgb(197 59 108);
  margin: 10px 10px;
  &:hover {
    background-color: rgb(197 59 108);
  }
`;

const StyledLink = styled.a`
  text-transform: none !important;
  cursor: pointer;
  font-size: 25px;
  color: rgb(104 38 85);
  &:hover {
    color: white;
  }
  @media (max-width: 700px) {
    font-size: 15px;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  background: none;
  font-size: 2rem;
  border: none;
  cursor: pointer;

  @media (max-width: 700px) {
    display: flex;
    justify-content: flex-end;
  }
`;

const Header: React.FC = () => {
  const { t } = useTranslation();

  const english = "ES";
  const spanish = "EN";
  const [buttonText, setButtonText] = useState(spanish);
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = searchParams.get("lang");

  useEffect(() => {
    window.scrollTo(0, 0);

    if (lang === "en") {
      setButtonText(english);
    } else if (lang === "es") {
      setButtonText(spanish);
    }
  }, [lang]);

  return (
    <Container>
      <HeaderContainer>
        <MainPicture src={headerIcon} alt="header" />
      </HeaderContainer>

      <div style={{ display: "flex", alignItems: "center" }}>
        <ButtonContainer>
          <StyledLink
            onClick={() => {
              let intendedLanguage;
              if (buttonText === english) {
                intendedLanguage = "es";
              } else {
                intendedLanguage = "en";
              }
              searchParams.set("lang", intendedLanguage);
              setSearchParams(searchParams, { replace: true });
            }}
          >
            {buttonText}
          </StyledLink>
        </ButtonContainer>

        <HamburgerButton
          onClick={() => {
            // You can pass a callback or state toggle from App and Menu if needed
            document.dispatchEvent(new CustomEvent("toggle-menu"));
          }}
        >
          ☰
        </HamburgerButton>
      </div>
    </Container>
  );
};

export default Header;
